var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer mt-6 has-background-primary has-text-light"},[_c('div',{staticClass:"content has-text-centered has-text-weight-bold"},[_c('p',[_vm._v("NLV Media Transcoder. Developed by "),_c('a',{staticClass:"has-text-light",attrs:{"href":"https://modernizd.com","target":"_blank","rel":"nofollow"}},[_vm._v("Modernizd.")])])])])
}]

export { render, staticRenderFns }